export default __webpack_public_path__ + "static/media/logoCredit__2_-removebg-preview.1cce599b.png";